import React, { useEffect, useRef, useState } from "react";
import { Pause, Play, Copy } from "lucide-react";

const LEVEL_CLASS = {
    info: "text-[#A7B4C6]",
    success: "text-[#2BE38B]",
    warn: "text-[#FFB020]",
    error: "text-[#FF5C6C]",
};

const fmtTime = (ts) => {
    if (!ts) return "--:--:--";
    const d = new Date(ts);
    const hh = String(d.getHours()).padStart(2, "0");
    const mm = String(d.getMinutes()).padStart(2, "0");
    const ss = String(d.getSeconds()).padStart(2, "0");
    const ms = String(d.getMilliseconds()).padStart(3, "0");
    return `${hh}:${mm}:${ss}.${ms}`;
};

export const TerminalLog = ({ events = [] }) => {
    const [autoscroll, setAutoscroll] = useState(true);
    const ref = useRef(null);

    useEffect(() => {
        if (autoscroll && ref.current) {
            ref.current.scrollTop = ref.current.scrollHeight;
        }
    }, [events, autoscroll]);

    const copyLatest = () => {
        const text = events
            .slice(-200)
            .map((e) => `[${fmtTime(e.ts_ms)}] [${(e.level || "info").toUpperCase()}] ${e.msg}`)
            .join("\n");
        try {
            navigator.clipboard.writeText(text);
        } catch (_) { /* noop */ }
    };

    return (
        <div className="panel" data-testid="event-log-panel">
            <div className="flex items-center justify-between px-4 py-3 border-b border-[#1B2A3A]">
                <div className="text-[10px] uppercase tracking-[0.18em] text-[#A7B4C6]">Event Log</div>
                <div className="flex items-center gap-2">
                    <button
                        onClick={() => setAutoscroll((x) => !x)}
                        className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.14em] px-2 py-1 rounded-md btn-anim"
                        style={{ color: autoscroll ? "#2EE6D6" : "#A7B4C6", border: "1px solid #1B2A3A" }}
                        data-testid="event-log-autoscroll-toggle"
                    >
                        {autoscroll ? <Pause size={12} /> : <Play size={12} />}
                        {autoscroll ? "Pause" : "Resume"}
                    </button>
                    <button
                        onClick={copyLatest}
                        className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.14em] px-2 py-1 rounded-md btn-anim"
                        style={{ color: "#A7B4C6", border: "1px solid #1B2A3A" }}
                        data-testid="event-log-copy-button"
                    >
                        <Copy size={12} /> Copy
                    </button>
                </div>
            </div>
            <div
                ref={ref}
                className="log-scroll font-mono text-xs leading-[1.55] px-4 py-3 overflow-y-auto"
                style={{ background: "#05070A", height: 280, color: "#A7B4C6" }}
            >
                {events.length === 0 && (
                    <div className="text-[#3A4759]">[idle] no events yet — start the bot to see live activity.</div>
                )}
                {events.map((e, i) => (
                    <div key={`${e.ts_ms}-${i}`} className="flex gap-3">
                        <span style={{ color: "#3A4759" }}>[{fmtTime(e.ts_ms)}]</span>
                        <span className={LEVEL_CLASS[e.level] || LEVEL_CLASS.info}>
                            [{(e.level || "info").toUpperCase().padEnd(5, " ")}]
                        </span>
                        <span>{e.msg}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TerminalLog;
